import type { InjectionKey } from "vue";
import type {
  actionDialogProvideFunctions,
  snackbarProvideFunctions,
} from "./interfaces/common";

export const snackbarKey = Symbol() as InjectionKey<snackbarProvideFunctions>;
export const actionDialogKey =
  Symbol() as InjectionKey<actionDialogProvideFunctions>;
